module.exports = __webpack_public_path__ + "img/fc_logo.3f724485.png";